import React, { Component } from "react";
import { observer } from "mobx-react";
import "./AddToPlaylist.scss";
import AddToPlaylistState from "./AddToPlaylistState";
import MusicTrackState from "../MusicTrack/MusicTrackState";
/** @typedef {import("../../../sql/schemaDatatypes").SavedPlaylistSql} SavedPlaylistSql */

/**
 * @typedef {Object} AddToPlaylistProps
 * @property {AddToPlaylistState} store - The add to playlist state store
 * @property {(search: SavedPlaylistSql) => void} addToExistingSearch - Function to add to existing search
 * @property {(track: MusicTrackState) => void} trackBelongsToCurrentPlaylist - Function to check track membership
 */

@observer
class AddToPlaylist extends Component {
  render() {
    const existingSearches = this.props.store.searchState.myAccountState.savedTracksOrganized();
    let filteredSearches = existingSearches;

    if (this.props.store.filterSavedTerm) {
      filteredSearches = existingSearches.filter(playlist => {
        const name = playlist.name ? playlist.name : ``;
        if (
          name
            .toLowerCase()
            .includes(this.props.store.filterSavedTerm.toLowerCase())
        ) {
          return playlist;
        }
        return false;
      });
    }

    const playlistsResult = filteredSearches.map((search) => (
      <li
        className={"AddToPlaylistMenu-choice"}
        key={search.id}
        onMouseDown={() => {
          this.props.store.addToExistingSearch(search);
          this.props.store.close();
        }}
      >
        {search.name}
      </li>
    ));

    let playlistContent;
    let headlineContent;

    if (this.props.store.showingNewPlaylist === false) {
      headlineContent = "Add to playlist";
      playlistContent = (
        <div>
          <div>
            <input
              placeholder={"search playlists"}
              onChange={e => {
                this.props.store.filterPlaylists(e.target.value);
              }}
              onKeyDown={e => {
                e.stopPropagation();
              }}
            />
          </div>
          <div>
            <ul>{playlistsResult}</ul>
          </div>
          <div className={"buttons"}>
            <button
              type={"button"}
              className={"Popup-button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.close();
              }}
            >
              cancel
            </button>
            <button
              type={"button"}
              className={"Popup-button red"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.toggleShowingNewPlaylist();
              }}
            >
              new playlist
            </button>
          </div>
        </div>
      );
    } else {
      headlineContent = "New playlist";
      playlistContent = (
        <div>
          <div>
            <input
              placeholder={"playlist name"}
              onChange={e => {
                if (e.target.value.length > 1) {
                  this.props.store.searchState.myAccountState.setSaveName(
                    e.target.value
                  );
                  this.props.store.searchState.saveSingleTrackToNewSearch(
                    this.props.store.searchState.idToAddToPlaylist.toString()
                  );
                }
              }}
              onKeyDown={e => {
                e.stopPropagation();
              }}
            />
            <br />
            <br />
          </div>
          <div className={"buttons"}>
            <button
              type={"button"}
              className={"Popup-button"}
              onClick={this.props.store.close}
            >
              cancel
            </button>
            <button
              type={"button"}
              className={"Popup-button red"}
              onClick={() => {
                this.props.store.searchState.myAccountState.saveNewSearch();
                this.props.store.close();
              }}
            >
              save
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className={"AddToPlaylist"}>
        <div className={"AddToPlaylist-holder"}>
          <div className={"AddToPlaylist-header"}>{headlineContent}</div>
          <div
            className={"Popup-banner-close"}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              this.props.store.close();
            }}
          />
          <div className={"AddToPlaylist-content-holder"}>
            {playlistContent}
          </div>
        </div>
        <div
          className={"AddToPlaylist-background"}
          onClick={this.props.store.close}
        />
      </div>
    );
  }
}

export default AddToPlaylist;
